<div [formGroup]="formGroup">
  <div class="question-group">
    <span class="question-label">
      {{ label }} <span class="required">*</span>
    </span>
    <div class="options">
      <label>
        <up-checkbox [class.checkbox-error]="formGroup.invalid && isSubmitted">
          <input
            type="checkbox"
            formControlName="origin"
            (change)="onSelect('origin')"
          />
        </up-checkbox>
        Yes, at origin
      </label>
      <label>
        <up-checkbox [class.checkbox-error]="formGroup.invalid && isSubmitted">
          <input
            type="checkbox"
            formControlName="destination"
            (change)="onSelect('destination')"
          />
        </up-checkbox>
        Yes, at destination
      </label>
      <label>
        <up-checkbox [class.checkbox-error]="formGroup.invalid && isSubmitted">
          <input
            type="checkbox"
            formControlName="no"
            (change)="onSelect('no')"
          />
        </up-checkbox>
        No
      </label>
    </div>
  </div>
  @if(formGroup.invalid && isSubmitted){
  <div class="error-message">Please select any one or more.</div>
  }
</div>
<br>
